export const FORCED_TOOL_CHOICE_CONTEXT_KEY = Symbol("forcedToolChoice");
export const AGENT_REF_CONTEXT_KEY = Symbol("agentRef");
export const TOOL_ROUTING_CONTEXT_KEY = Symbol("toolRoutingConfig");
export const TOOL_ROUTING_SEARCHED_TOOLS_CONTEXT_KEY = Symbol("toolRoutingSearchedTools");
export const SPECULATIVE_INPUT_GUARDRAIL_CONTEXT_KEY = Symbol("speculativeInputGuardrail");
